import React, { useState, useEffect } from 'react';
import {
    getOrderForPayment,
    uploadOrderPaymentSlip,
    orderPaymentConfirmation
} from "../../store/action/order";
import numeral from "numeral";
import { Button } from "../../components/buttons";
import ReactInterval from "react-interval";
import { getContrast } from "../../services/helpers/color";


const CatalogPayment = props => {
    const [ loading, setLoading ] = useState(true);
    const [ order, setOrder ] = useState({
        paymentSlip:'',
        images: {},
        items:[]
    });
    const [ catalog, setCatalog ] = useState({
        bankAccounts:[],
        style: {}
    });
    const [ values, setValues ] = useState({
        tab:'confirmation',
        paymentImageLoading: false,
        submitLoading:false
    });

    useEffect(() => {
        _fetchData();
    }, []);

    const _fetchData = async () => {
        setLoading(true);
        let orderId = props.match.params.orderId;
        let uniqueCode = props.match.params.uniqueCode;

        try {
            const res = await getOrderForPayment(orderId);
            if ( res.success ) {
                let newOrder = res.order;
                let newCatalog = res.catalog;
                let totalPrice = newOrder.items.reduce((res,i) => {
                    res += i.value*i.quantity;
                    return parseInt(res)
                },[]);
                setOrder({
                    ...order,
                    ...newOrder,
                    uniqueCode: uniqueCode,
                    courierCompany: newOrder.courier.company,
                    courierType: newOrder.courier.type,
                    totalPrice: totalPrice
                });
                setCatalog({
                    ...newCatalog,
                    bankAccounts: res.bankAccounts
                })
            } else {
                alert(`Gagal ambil data order. ${res.error}`)
            }
        } catch (e) {
            console.log (e);
            alert(e.message)
        }
        setLoading(false)
    };

    const onSelectPaymentSlipImage = async (e) => {
        setValues({...values, paymentImageLoading:true});
        const data = e.target.files[0];
        const res = await uploadOrderPaymentSlip(data);
        if(res.success) {
            setOrder({
                ...order,
                paymentSlip: res.image

            });
            setValues({
                ...values,
                paymentImageLoading:false
            })
        } else {
            alert("Foto produk gagal diupadte. Coba ulangi lagi yuk!");
            setValues({
                ...values,
                paymentImageLoading:false
            })
        }
    };

    const onSubmitPayment = async () => {
        try {
            const res = await orderPaymentConfirmation(order._id, order.paymentSlip);
            if ( res.success) {
                setValues({
                    ...values,
                    tab:'finish',
                    submitLoading:false
                });
                setOrder({
                    ...order,
                    paymentSlip: res.order.images.paymentSlip
                })
            } else {
                alert("Gagal ambil data")
                setValues({
                    ...values,
                    submitLoading:false
                });
            }
        } catch (e) {
            console.log (e);
            alert(e.message)
            setValues({
                ...values,
                submitLoading:false
            });
        }
    };

    let totalPrice = `Rp. ${numeral(order.price + order.totalPrice + parseInt(order.uniqueCode)).format("0,0")}`;
    let uniqueCode = totalPrice.substr(totalPrice.length -3);
    let filteredUnique = totalPrice.slice(0, -3);
    let totalPriceView = (
        <div>
            <h3><b>{filteredUnique}<mark>{uniqueCode}</mark></b></h3>
        </div>
    );
    let body;

    if ( values.tab === 'finish' ) {
        body = (
            <div className={`text-left bg-white py-4 px-2 border rounded-bottom`}>
                <div className="my-2 text-center">
                    <i style={{fontSize: 32}} className="fas fa-check-circle text-success"/><br/>
                    <span><b className="text-black text-lg">Upload Bukti Pembayaran Berhasil!</b></span> <br/>
                </div>
                <div className="text-center">
                    <p className="mb-1">No Transaksi Anda</p>
                    <h6 className="text-uppercase"><mark>{order._id}</mark></h6>
                </div>
                <div className="my-2 text-center">
                    <p>Kami segera memproses pesanan Anda. Mohon ditunggu ya!</p>
                </div>
            </div>
        )
    } else if ( order.images.paymentSlip ) {
        body = (
            <div className={`text-left bg-white py-4 border rounded-bottom`}>
                <div className="container">
                    <div className="my-2 text-center">
                        <i style={{fontSize: 32}} className="fas fa-check-circle text-success"/><br/>
                        <span><b className="text-black text-lg">Anda sudah upload bukti pembayaran</b></span> <br/>
                    </div>
                    <div className="text-center">
                        <p className="mb-1">No Transaksi Anda</p>
                        <h6 className="text-uppercase"><mark>{order._id}</mark></h6>
                    </div>
                    <div className="my-2 text-center">
                        <p>Kami sedang memproses pesanan Anda. Mohon ditunggu ya!</p>
                    </div>
                    <h6>Foto Bukti Pembayaran</h6>
                    <div className="px-4 py-3 border bg-lighter rounded">
                        <div className="text-center">
                            <div>
                                <img
                                    src={order.images.paymentSlip}
                                    style={{height:42, width:42}}
                                    className="rounded border"
                                />
                            </div>
                            <div>
                                <div className="pt-2"/>
                                <i className="fas fa-check-circle text-success text-lg"></i>
                                <span><b className="text-black text-lg">{" "} Berhasil Upload</b></span> <br/>
                                <div
                                    onClick={() => {
                                        setValues({...values, paymentImageLoading:false});
                                        setOrder({...order, images:{}, paymentSlip:''})
                                    }}
                                    className="badge-info badge py-2">
                                    Mau edit/ganti gambar? klik disini
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    } else if (!order.images.paymentSlip) {
        body = (
            <div className={`text-left bg-white py-4 border rounded-bottom`}>
                <div className="container">
                    <h6>Upload Bukti Pembayaran</h6>
                    <div className="p-4 border bg-lighter rounded">
                        {
                            order.items.map((i,idx) => (
                                <div key={idx} className="row py-1">
                                    <div className="col-9">
                                        <div className="row">
                                            <div className="col-4 pt-1">
                                                {
                                                    i.image ?
                                                        <img src={i.image} style={{height:35, width:36}} className="rounded"/> :
                                                        <i>no image</i>
                                                }
                                            </div>
                                            <div className="col-6 text-left">
                                                {i.quantity}x - <b>{i.name}</b>
                                                <p className="mb-0">{i.description}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-3 text-right">
                                        <b>Rp. {numeral(i.value*i.quantity).format("0,0")}</b>
                                    </div>
                                </div>
                            ))
                        }
                        <div className="row justify-content-between">
                            <div className="col-6">
                                Kurir <b>{order.courierCompany} - { order.courierType}</b>
                            </div>
                            <div className="col-6 text-right">
                                <b>Rp. {numeral(order.price).format("0,0")}</b>
                            </div>
                        </div>
                        <br/>
                        <div className="row justify-content-between">
                            <div className="col-6">
                                Kode Unik Pembayaran
                            </div>
                            <div className="col-6 text-right">
                                <b>{order.uniqueCode}</b>
                            </div>
                        </div>
                        <div className="container">
                            <hr/>
                        </div>
                        <div className="text-center">
                            <h6>Total Pembayaran</h6>
                            { totalPriceView }
                        </div>
                        <div className="text-left">
                            <b className="text-danger">PENTING!</b>
                            <p className="mb-1">* Mohon masukkan 3 angka terakhir untuk memudahkan pengecekan</p>
                        </div>
                    </div>
                    <br/>
                    <h6>Transfer ke</h6>
                    <div className="px-4 py-2 border bg-lighter rounded">
                        {
                            catalog.bankAccounts.map(i => (
                                <div className="my-1">
                                    <h6 className="mb-0"><b>{i.bank}</b> - {i.account}</h6>
                                    a/n {i.name}
                                </div>
                            ))
                        }
                    </div>
                    <br/>
                    <h6>Foto Bukti Pembayaran</h6>
                    {
                        order.paymentSlip ?
                            <div className="px-4 py-3 border bg-lighter rounded">
                                <div className="text-center">
                                    <div>
                                        <img
                                            src={order.paymentSlip}
                                            style={{height:42, width:42}}
                                            className="rounded border"
                                        />
                                    </div>
                                    <div>
                                        <div className="pt-2"/>
                                        <i className="fas fa-check-circle text-success text-lg"></i>
                                        <span><b className="text-black text-lg">{" "} Berhasil Upload</b></span> <br/>
                                        <div
                                            onClick={() => {
                                                setValues({...values, paymentImageLoading:false});
                                                setOrder({...order, paymentSlip:''})
                                            }}
                                            className="badge-info badge py-2">
                                            Mau edit/ganti gambar? klik disini
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            <div>
                                {
                                    values.paymentImageLoading ?
                                        <div className="text-center py-4">
                                            <h6 className="text-muted">Mohon ditunggu. Gambar sedang diupload...</h6>
                                            <div
                                                onClick={() => {
                                                    setValues({...values, paymentImageLoading:false});
                                                    setOrder({...values, paymentSlip:''})
                                                }}
                                                className="badge-info badge py-2">
                                                Teralu lama? Coba upload lagi dengan resolusi rendah klik disini.
                                            </div>
                                        </div>
                                        :
                                        <div className="custom-file mb-3 mt-1 ">
                                            <input
                                                type="file"
                                                className="upload-payment-image"
                                                id="file"
                                                accept="image/*"
                                                onChange={onSelectPaymentSlipImage}
                                            />
                                            <label
                                                htmlFor="file"
                                                className="btn btn-outline-primary btn-block btn-sm"
                                                style={{
                                                    backgroundColor: catalog.style.buttonColor,
                                                    borderColor: catalog.style.buttonBorderColor,
                                                    color: catalog.style.buttonFontColor
                                                }}
                                            >
                                                Upload Foto Bukti Pembayaran (Max 5MB)
                                            </label>
                                        </div>
                                }
                            </div>
                    }
                    <br/>
                </div>
                <div className="border-top col-12 pt-3">
                    <Button
                        onClick={ order.paymentSlip ?
                            () => setValues({...values, submitLoading:true}) :
                            () => alert("Harus upload foto bukti transfer terlebih dahulu")
                        }
                        loading={values.submitLoading}
                        className="btn btn-primary btn-block"
                        style={ order.paymentSlip ? {
                            backgroundColor: catalog.style.buttonColor,
                            borderColor: catalog.style.buttonBorderColor,
                            color: catalog.style.buttonFontColor
                        } : {
                            backgroundColor: '#ced4da',
                            borderColor: '#ced4da',
                            color: 'black'
                        }}
                    >
                        {values.submitLoading ? "Memproses..." : "Kirim Bukti Pembayaran"}
                    </Button>
                </div>
            </div>
        )
    }

    if (loading) {
        return <div className="bg-lighter"><b>Loading...</b></div>
    }

    return (
        <div className="px-0 border-top full-height"
             style={{
                 backgroundColor: catalog.style.backgroundColor
             }}
        >
            <ReactInterval
                timeout={2000}
                enabled={values.submitLoading}
                callback={() => onSubmitPayment()}
            />
            <div style={{backgroundColor: catalog.style.backgroundColor}}>
                <div className="px-4 public-form-layout" >
                    <div
                        style={{width:528}}
                        className="container mt-4">
                        <br/>
                        <div className="align-self-center">
                            <div
                                className="bg-lighter rounded-top"
                                style={{
                                    height:156,
                                    overflow: 'hidden',
                                    align: 'center'
                                }}
                            >
                                <img
                                    className="image-header-form"
                                    src={catalog.style.headerImage}
                                />
                            </div>
                        </div>
                        { body }
                    </div>
                </div>
            </div>
            <div
                style={{
                    paddingTop: 64,
                    paddingBottom:64,
                    backgroundColor: catalog.style.backgroundColor
                }}
            >
                <div className="text-center public-form-layout">
                    <a
                        href='https://www.biteship.com'
                        style={ getContrast(`#000000`) === 'white' ? {color:'white'} : {color:'black'}}
                    >
                        <p className="mb-1">
                            Form Powered by <i><b>Biteship</b></i>
                        </p>
                        <div style={{fontSize:12}}>
                            www.biteship.com
                        </div>
                    </a>
                </div>
            </div>
        </div>
    )
};

export default CatalogPayment;
